import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppInformationService, AuthService, GenesisUnitOfWork } from 'app/core/core.module';
import { OrderLineDetail } from 'app/core/model/entity-model';
import { OrderDetailComponent } from 'app/orders/order-detail/order-detail.component';
import { PartDetailComponent } from 'app/parts/part-detail/part-detail.component';
import { PartPurchaseOrderDialogComponent } from 'app/parts/part-po-dialog/part-po-dialog.component';
import { SharedModule } from 'app/shared/shared.module';
import { DxDataGridComponent } from 'devextreme-angular';
import _ from 'lodash';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-parts-overview',
    templateUrl: './parts-overview.component.html',
    styleUrls: ['./parts-overview.component.scss'],
    standalone: false
})
export class PartsOverviewComponent implements OnInit {
    parts: any;
    workOrderList: any[];
    showAllOrders = false;
    filter: any;
    statusList: any[];
    selectedStatuses = [];
    partInfos: any;
    selectedSum = 0;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    @ViewChild('detailGrid') detailGrid: DxDataGridComponent;
    onExporting = SharedModule.onExporting;

    constructor(private uow: GenesisUnitOfWork, public auth: AuthService, private modalService: BsModalService, private appInfo: AppInformationService, private router: Router) {}

    async ngOnInit() {
        this.parts = [];
        this.partInfos = [];
        this.statusList = this.uow.lookups.orderLineStatuses;
        this.selectedStatuses = [OrderLineDetail.Statuses.New];
    }

    async searchByStatus() {
        this.appInfo.pleaseWaitShow();
        this.parts = await this.uow.getOrderLineDetailPartsOverview(this.selectedStatuses);
        // this.parts.forEach((part) => {
        //     if (part.newInStock < 0) part.newInStock = 0;
        // });  //undoing this because the zero made them think the inventory numbers were accurate but should have been negative
        this.appInfo.pleaseWaitHide();
    }

    // this method is used to clear the selection when the user searches for something
    onOptionChanged(e) {
        if (e.fullName === 'searchPanel.text') {
            e.component.__searchChanged = true;
        }
        const filterCheck = _.includes(e.fullName, 'filterValue');
        if (filterCheck) {
            this.dataGrid.instance.clearSelection();
        }
    }

    // this method is used to clear the selection when the user searches for something
    onContentReady(e) {
        if (e.component.__searchChanged) {
            //__searchChanged is for the search box
            e.component.__searchChanged = false;
            this.dataGrid.instance.clearSelection();
        }
    }

    // this method is used to clear the selection when the user searches for something
    onDetailOptionChanged(e) {
        if (e.fullName === 'searchPanel.text') {
            e.component.__searchChanged = true;
            this.detailGrid.instance.clearSelection();
            this.selectedSum = 0;
        }
    }

    // this method is used to clear the selection when the user searches for something
    onDetailContentReady(e) {
        const filter = e.component.getCombinedFilter();
        if (e.component.__searchChanged || !!filter) {
            e.component.__searchChanged = false;
            this.detailGrid.instance.clearSelection();
            this.selectedSum = 0;
        }
    }

    rowPrepare(e) {
        if (e.rowType === 'data') {
            if (e.data.projectedInventory < 0) {
                for (let index = 0; index < e.cells.length; index++) {
                    const element = e.cells[index];
                    if (element.column.dataField === 'projectedInventory')
                        element.cellElement.className = element.cellElement.className + ' overview-red-row'
                }
            }
        }
    }

    async selectionChange(e) {
        // console.log(e);
        if (!!e.selectedRowsData && e.selectedRowsData.length > 0)
            this.partInfos = await this.uow.getOrderLineDetailsByPartAndStatusOverview(e.selectedRowsData[0].partId, e.selectedRowsData[0].statusId);
    }

    async detailSelectionChange(e) {
        this.selectedSum = 0;
        if (!!e.selectedRowsData && e.selectedRowsData.length > 0)
            e.selectedRowsData.forEach((row) => {
                this.selectedSum += row.quantity;
            });
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    async open(orderId: number) {
        const modalRef = this.modalService.show(OrderDetailComponent, {
            class: 'modal-lg',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                orderId: orderId,
                showAsDialog: true,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
            }
            modalRef.hide();
        });
    }

    async partDetailDialog(partId: number) {
        const modalRef = this.modalService.show(PartDetailComponent, {
            class: 'modal-lg',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                showAsDialog: true,
                partId: partId,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            modalRef.hide();
        });
    }

    async purchaseOrderDialog(partId: number) {
        const modalRef = this.modalService.show(PartPurchaseOrderDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                partId: partId,
            },
        });

        modalRef.content.result.subscribe((result) => {
            if (result.success && !!result.value) {
                this.openPurchaseOrder(result.value);
            }
            modalRef.hide();
        });
    }

    async openPurchaseOrder(id: number) {
        this.router.navigate(['/purchase-orders/' + id]);
    }

    // async rowDoubleClick(e) {
    //     await this.open(e.data.id);
    // }
}
